export enum FrmaPagesEnum {
    BeforeYouBegin = 1,
    ThingsYouWillNeed = 2,
    Signature = 3,
    StudentsInTheHousehold = 4,
    AssistancePrograms = 5,
    FosterCare = 6,
    YourChildrenCanAlsoQualify = 7,
    ContinueorSubmit = 8,
    OtherChildrenInTheHousehold = 9,
    TheNextFewQuestionsAreAboutYourChildrensIncome = 10,
    DoesStudentHaveIncomeFromAnyOfTheFollowingSources = 11,
    WhatAdultsLiveInYourHousehold = 12,
    TheNextQuestionsAreAllAboutNameOfAdult = 13,
    MilitaryIncome = 14,
    EarningsFromWork = 15,
    IncomeFromPublicAssistance = 16,
    IncomeFromAlimonyorChildSupport = 17,
    IncomeFromBenefits = 18,
    RetirementIncome = 19,
    OtherSourcesofIncome = 20,
    AlmostDone = 21,
    UseofInformationUSDANonDescrimination = 22,
    SharingInformationwithOtherPrograms = 23,
    CertifyandSubmit = 24,
    Thankyou = 25
}

export enum FrmaProgramsEnum {
    SNAP = 1,
    TANF = 2,
    FDPIR = 3,
    McKinneyVento = 4,
    MEP = 5,
    RunawayYouth = 6
}



export enum FrmaAdultIncomeTypesEnum {
    Military = 1,
    Employment = 2,
    PublicAssistance = 3,
    AlimonyChildSupport = 4,
    Benefits = 5,
    Retirement = 6,
    Other = 7
}

export enum AcceptRejectModesEnum {
    SnapTanfFdpir = 1,
    AllFoster = 2,
    AllFosterHomelessMigrantOrRunaway = 3,
    Other = 4
}
